import { Grid, Stack } from "@mui/material";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import {
  EncounterText,
  EncounterGrid,
  EncounterTimerContainer,
  EncounterTitleText,
  EncounterTextField
} from "../EncounterTimer/EncounterTimer.styles";
import { useContext, useEffect, useState, useRef } from "react";
import { GlobalContext } from "../../../context/Provider";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import { AddEncounterEvent, saveActiveEncounter } from "helpers/variables";
import { NotesObject } from "context/initialState/Notes";
import Session from "helpers/session";
import API from "api";

export function EncounterTimerDisplay() {
  const theme = useTheme();
  const { member, memberDispatch, encounters, encounterDispatch, encounterTimer, encounterTimerDispatch, settingsDispatch } =
    useContext(GlobalContext);
  const seconds = encounterTimer?.current?.duration || 0;
  const { t } = useTranslation();
  const [eventBody] = useState({
    coordinatorId: Session ? Session.crackCookieUserId("coordinator") : "",
    coordinatorName: Session ? Session.crackCookieUsername("coordinator") : "",
    memberId: member?.current ? member?.current.id : "",
    memberName: member?.current ? member?.current.username : "",
    duration: member ? member?.secondsCounter.toString() : "",
    escalatedDuration: 1,
    actions: encounters?.current ? encounters?.current : []
  });
  const [, forceTick] = useState(0);

  const HandleNoteOpen = () => {
    memberDispatch({
      type: "UPDATE_ENCOUNTER_NOTE_OPEN",
      payload: !member?.noteOpen
    });
  };

  const HandleNoteSubmit = () => {
    const noteText = member?.notesContent || "";

    const noteBody: NotesObject = {
      memberId: member?.current.id || "",
      authorId: Session.crackCookieUserId("coordinator"),
      authorName: Session.crackCookieUsername("coordinator"),
      content: noteText,
      type: "staff"
    };

    API.kore.notes
      .create(noteBody, Session.crackCookieToken("coordinator"))
      .then(() => {
        const encounterEvent = AddEncounterEvent(
          "note",
          noteText || "Added Staff Note"
        );
        const duration = encounterTimer?.current?.duration;
        Session.updateSessionEncounter(
          window.sessionStorage.getItem("encounter") ||
          Session.encrypt(JSON.stringify(eventBody)),
          encounterEvent,
          duration?.toString() || ""
        );
      })
      .catch((err) => console.log(err));

    memberDispatch({ type: "UPDATE_ENCOUNTER_CONTENT", payload: "" });
    memberDispatch({
      type: "UPDATE_ENCOUNTER_NOTE_OPEN",
      payload: !member?.noteOpen
    });
  };

  const timerRef = useRef(0);
  timerRef.current = encounterTimer?.current?.duration || 0;

  useEffect(() => {
    if (!window.sessionStorage.getItem("encounter")) {
      window.sessionStorage.setItem(
        "encounter",
        Session.encrypt(JSON.stringify(eventBody))
      );
    }

    const handlePageHide = () => saveActiveEncounter(
      member,
      encounterTimerDispatch,
      settingsDispatch,
      timerRef.current,
      true
    );
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      forceTick(t => t + 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <Grid container>
      <Grid item xs={0} sm={0} md={1.5} lg={0.7} />
      <Grid item xs={12} sm={12} md={9.8} lg={10.8}>
        <EncounterTimerContainer>
          <EncounterGrid container>
            <Grid item xs={3} md={3} lg={4}>
              <EncounterTitleText>
                {t("u-current-encounter")}
              </EncounterTitleText>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <EncounterText>
                {t("u-starts-at")}{" "}
                {moment(member?.encounterStart).format("HH:mm") || "00:00"}
              </EncounterText>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <EncounterText>
                {t("u-time")} {Math.floor(seconds / 60)}:
                {(seconds - Math.floor(seconds / 60) * 60).toLocaleString(
                  "en-US",
                  { minimumIntegerDigits: 2 }
                )}
              </EncounterText>
            </Grid>
            <Grid item xs={5} md={5} lg={4}>
              <Stack spacing={0.5} direction="row">
                <Button
                  variant="warning"
                  height={theme.spacing(6)}
                  onClick={() => {
                    if (encounterTimer?.current?.pause) {
                      encounterTimerDispatch({ type: "UNPAUSE_ENCOUNTER_TIMER" });
                    } else {
                      encounterTimerDispatch({ type: "PAUSE_ENCOUNTER_TIMER" });
                    }
                  }}
                >
                  {encounterTimer?.current?.pause ? t("u-resume") : t("u-pause")}
                </Button>
                <Button
                  variant="primary"
                  height={theme.spacing(6)}
                  width="33%"
                  onClick={HandleNoteOpen}
                >
                  {member?.noteOpen === false ? t("u-open-note") : "Close Note"}
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={0} md={0} lg={0} />
          </EncounterGrid>
          <Stack
            sx={{
              display: `${member?.noteOpen ? "block" : "none"}`
            }}
          >
            <EncounterTextField
              defaultValue={member?.notesContent}
              onBlur={(e) => {
                memberDispatch({
                  type: "UPDATE_ENCOUNTER_CONTENT",
                  payload: e.target.value
                });
              }}
              placeholder="Enter note"
              fullWidth
              multiline
              maxRows={2}
              minRows={2}
            />
            <Button
              variant="success"
              height={theme.spacing(6)}
              width={theme.spacing(30)}
              onClick={HandleNoteSubmit}
            >
              Submit
            </Button>
            <Grid container>
              <Grid item xs={6} />
              <Grid item xs={2}></Grid>
              <Grid item xs={4} />
            </Grid>
          </Stack>
        </EncounterTimerContainer>
      </Grid>
      <Grid item xs={0} sm={0} md={0.7} lg={0.5} />
    </Grid>
  );
}